const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#14213d",
    },
    secondary: {
      main: "#fca311",
    },
    error: {
      main: "#e63946",
    },
    warning: {
      main: "#ffc300",
    },
    info: {
      main: "#a8dadc",
    },
    success: {
      main: "#007200",
    },
  },
  typography: {
    fontFamily: "Montserrat",
  },
};

export default themeOptions;
